module.exports = __webpack_public_path__ + "static/media/lo.653efcd4.ogg";